module.exports = __webpack_public_path__ + "static/media/Novosti2.cc6a36ce.png";